import React, { Component } from 'react';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { ChartProgrammesParPhase } from '../Graphique/ChartProgrammesParPhase';
import { ChartQueuesDeProgramme } from '../Graphique/ChartQueuesDeProgramme';
import { ChartSouhaitsRDV } from '../Graphique/ChartSouhaitsRDV';
import { ChartSuiviCommercial } from '../Graphique/ChartSuiviCommercial';
import { ChartDernierSuiviCommercial } from '../Graphique/ChartDernierSuiviCommercial';
import { ChartAlarmeSouhaitAVenir } from '../Graphique/ChartAlarmeSouhaitAVenir';
import { ChartEtatContratReservation } from '../Graphique/ChartEtatContratReservation';
import PerimetreContext from '../../contexts/PerimetreContext';

export class TableauDeBord extends Component {
    static contextType = PerimetreContext;
    render = () => {
        const { perimetre } = this.context;
        return <TableauDeBordWithPerimetre {...this.props} perimetre={perimetre} />;
    };
};

class TableauDeBordWithPerimetre extends Component {

    static defaultProps = {
        perimetre: {}
    };

    //componentDidUpdate = () => {
    //    if (localStorage.getItem("onRecharge") === "true") {
    //        localStorage.setItem("onRecharge", "false");
    //        //Rechargement de chaque composant de la page
    //        this.refs.refChartProgrammesParPhase._onRechargement();
    //        this.refs.refChartQueuesDeProgramme._onRechargement();
    //        this.refs.refChartSouhaitsRDV._onRechargement();
    //        this.refs.refChartSuiviCommercial._onRechargement();
    //        this.refs.refChartDernierSuiviCommercial._onRechargement();
    //        this.refs.refChartAlarmeSouhaitAVenir._onRechargement();
    //        this.refs.refChartEtatContratReservation._onRechargement();
    //    }
    //};

    componentDidUpdate = (prevProps) => {
        const { perimetre } = this.props;
        if (JSON.stringify(prevProps.perimetre) !== JSON.stringify(perimetre)) {
            //Rechargement de chaque composant de la page
            this.refs.refChartProgrammesParPhase._onRechargement();
            this.refs.refChartQueuesDeProgramme._onRechargement();
            this.refs.refChartSouhaitsRDV._onRechargement();
            this.refs.refChartSuiviCommercial._onRechargement();
            this.refs.refChartDernierSuiviCommercial._onRechargement();
            this.refs.refChartAlarmeSouhaitAVenir._onRechargement();
            this.refs.refChartEtatContratReservation._onRechargement();
        }
    };

    render = () => <Stack horizontal horizontalAlign="space-around" wrap>
        <ChartProgrammesParPhase ref="refChartProgrammesParPhase" />
        <ChartQueuesDeProgramme ref="refChartQueuesDeProgramme" />
        <ChartSouhaitsRDV ref="refChartSouhaitsRDV" />
        <ChartSuiviCommercial ref="refChartSuiviCommercial" />
        <ChartDernierSuiviCommercial ref="refChartDernierSuiviCommercial" />
        <ChartAlarmeSouhaitAVenir ref="refChartAlarmeSouhaitAVenir" />
        <ChartEtatContratReservation ref="refChartEtatContratReservation" />
    </Stack>;

}